import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import NewsDetailPage from './pages/NewsDetailPage';
import ConsentManagementPage from './pages/ConsentManagementPage';
import LegalDocumentsViewer from '../../components/LegalDocumentsViewer';
import ProtectedRoute from './components/ProtectedRoute';

// Lazy load ProfileEditPage since it uses geolocation hook that requires authentication
const ProfileEditPage = lazy(() => import('./pages/ProfileEditPage'));

function PublicApp() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/news/:id" element={<NewsDetailPage />} />
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/profile/edit" 
        element={
          <ProtectedRoute>
            <Suspense fallback={
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
              </Box>
            }>
              <ProfileEditPage />
            </Suspense>
          </ProtectedRoute>
        } 
      />      <Route 
        path="/consent-management" 
        element={
          <ProtectedRoute>
            <ConsentManagementPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/legal/:docType?" 
        element={<LegalDocumentsViewer />} 
      />
      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
}

export default PublicApp;
